import React, { Component } from 'react';

import AppModal from 'components/modal/appModal';

export class BlacklistConfirmationModalContent extends Component<any> {
  handleSubmit = () => {
    const {
      participant: { blacklist },
      participantId,
      updateParticipant,
    } = this.props;

    updateParticipant(participantId, !blacklist);
  };

  render() {
    const {
      id,
      participant: { fullName, blacklist },
    } = this.props;

    return (
      <AppModal
        id={id}
        title="Blacklist confirmation"
        hideOpenButton
        submitButtonLabel="Yes"
        submitAction={this.handleSubmit}
        closeButtonLabel="No"
      >
        {blacklist
          ? `Are you sure you want to remove ${fullName} from the Blacklist?`
          : `Are you sure you want to add ${fullName} to the Blacklist?`}
      </AppModal>
    );
  }
}
